var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLockGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#646F7C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.016 15.824c.542 0 .947-.14 1.215-.421.269-.281.403-.717.403-1.308V9.1c0-.586-.134-1.018-.403-1.296-.201-.209-.48-.34-.835-.392l-.051-.005V5.819c0-.66-.1-1.234-.3-1.725-.2-.49-.472-.898-.817-1.223-.344-.325-.732-.568-1.164-.729-.432-.161-.88-.242-1.344-.242-.464 0-.912.081-1.344.242-.432.161-.82.404-1.165.729-.344.325-.616.732-.816 1.223-.2.49-.3 1.066-.3 1.725l-.001 1.589-.048.004c-.353.053-.631.183-.834.392-.271.278-.407.71-.407 1.296v4.995c0 .591.136 1.027.407 1.308.27.28.675.42 1.212.42h6.592zm-1.092-8.437H6.522V5.694c0-.517.1-.957.297-1.318.198-.361.464-.636.798-.824.335-.188.702-.282 1.103-.282.405 0 .774.094 1.106.282.332.188.598.463.798.824.2.361.3.8.3 1.318v1.693zm.799 7.082H5.73c-.15 0-.264-.038-.34-.114-.076-.075-.114-.201-.114-.377V9.225c0-.176.038-.302.114-.378.076-.075.19-.113.34-.113h5.992c.146 0 .256.038.33.113.072.076.11.202.11.378v4.753c0 .176-.038.302-.11.377-.074.076-.184.114-.33.114z",
    transform: "translate(-13.000000, -625.000000) translate(13.000000, 608.000000) translate(0.000000, 17.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockGrey);
export default __webpack_public_path__ + "static/media/ic_lock_grey.e1d5e27dbe015a0afb87a0d179c4bb9c.svg";
export { ForwardRef as ReactComponent };